const errorsData = {
    loading: false,
    message: '',
    showErrorNotification: false,
    showErrorModal: false,
    errorTitle: ''
};

export default errorsData;
